const init = () => {
  const isSmartPhone = () => {
    const ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/iphone|Android.+Mobile/)) {
      return true;
    } else {
      return false;
    }
  };

  const setTelLink = () => {
    const items = document.querySelectorAll('.js-tel-link');
    if (items.length === 0) {
      return;
    }

    if (isSmartPhone()) {
      items.forEach(item => {
        item.innerHTML = '<a href="tel:' + item.textContent + '">' + item.textContent + '</a>';
      });
    }
  };

  setTelLink();
};

export default init;
